import React, { type ComponentType } from 'react';
import { TitleSlide } from './components/slides/TitleSlide';
import { PartnershipSlide } from './components/slides/PartnershipSlide';
import { TractionSlide } from './components/slides/TractionSlide';
import { WhyWhereSlide } from './components/slides/WhyWhereSlide';
import { EngagementLayerSlide } from './components/slides/EngagementLayerSlide';
import { TechStackSlide } from './components/slides/TechStackSlide';
import { ControlTowerSlide } from './components/slides/ControlTowerSlide';
import { ScalingSlide } from './components/slides/ScalingSlide';
import { ConcernsSlide } from './components/slides/ConcernsSlide';
import { PilotOptionsSlide } from './components/slides/PilotOptionsSlide';
import { ClosingSlide } from './components/slides/ClosingSlide';
export type DeckSlide = {
  // Stable id — keep it matching this slide's screen id in canvas.manifest.js.
  id: string;
  // On-slide title — should match the Screen name in canvas.manifest.js.
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_iyyusn',
  title: 'Shaping the Snakker Pilot for Leo Pharma',
  component: TitleSlide
}, {
  id: 'scr_partne',
  title: 'Brands thrive on attention',
  component: PartnershipSlide
}, {
  id: 'scr_tracti',
  title: 'Campaign after campaign, market after market',
  component: TractionSlide
}, {
  id: 'scr_concer',
  title: 'Questions worth asking',
  component: ConcernsSlide
}, {
  id: 'scr_whywhe',
  title: 'A new approach to engagement and conversion',
  component: WhyWhereSlide
}, {
  id: 'scr_jigsaw',
  title: "We're the engagement layer",
  component: EngagementLayerSlide
}, {
  id: 'scr_techst',
  title: 'Playing nicely with your tech stack',
  component: TechStackSlide
}, {
  id: 'scr_ctower',
  title: 'Visibility and control, not another project',
  component: ControlTowerSlide
}, {
  id: 'scr_scalin',
  title: 'Scaling fairly across local markets',
  component: ScalingSlide
}, {
  id: 'scr_pilots',
  title: 'Flexible pilot options for Q4',
  component: PilotOptionsSlide
}, {
  id: 'scr_closin',
  title: 'Prove it in Q4. Scale it in 2027.',
  component: ClosingSlide
}];